import React, { useState, useEffect, useCallback } from "react";
import { Quote } from "lucide-react";
import { PROJECTS } from "../mock";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const items = PROJECTS.items;
  const count = items.length;

  const go = useCallback((i) => setIdx((i + count) % count), [count]);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % count), 5500);
    return () => clearInterval(t);
  }, [count]);

  const active = items[idx];

  return (
    <section className="section-pad bg-white">
      <div className="container mx-auto px-4 max-w-[1200px]">
        <div className="site-heading text-center mb-12">
          <h4>Referenzen</h4>
          <h2>{PROJECTS.heading}</h2>
        </div>

        <div className="max-w-[760px] mx-auto text-center">
          <span
            className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-6"
            style={{ background: "rgba(27,110,243,0.1)", color: "#1b6ef3" }}
          >
            <Quote size={30} />
          </span>

          <p
            key={idx}
            className="text-lg md:text-xl leading-relaxed text-slate-600 mb-8"
            style={{ animation: "letterPulse 0.01s", transition: "opacity .4s" }}
          >
            {active.text}
          </p>

          <h4 className="text-lg font-semibold" style={{ color: "#141b34" }}>
            {active.name}
          </h4>
          <span className="text-sm text-[#1b6ef3] font-medium">{active.role}</span>

          {/* Avatar indicators */}
          <div className="flex items-center justify-center gap-4 mt-8">
            {items.map((it, i) => (
              <button
                key={i}
                onClick={() => go(i)}
                className="rounded-full overflow-hidden transition-all"
                style={{
                  width: i === idx ? 64 : 48,
                  height: i === idx ? 64 : 48,
                  border: i === idx ? "3px solid #1b6ef3" : "3px solid transparent",
                  opacity: i === idx ? 1 : 0.55,
                }}
                aria-label={it.name}
              >
                <img src={it.img} alt={it.name} className="w-full h-full object-cover" />
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
